import React from 'react'
import { modal } from '../../../core/utilities/modal';
import { apiIntegrations } from '../../../core/controllers/ApiIntegrations';

export default class APIKey extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            api_key: null,
        }
    }

    componentDidMount() {
        var self = this;
        apiIntegrations.getApiKey(function(response) {
            var key = response.key;
            self.setState({
                api_key: key,
            });
        })
    }

    componentWillUpdate(nextProps, nextState) {

    }

    handleDeleteApiKey() {
        var self = this;
        apiIntegrations.deleteApiKey(function(response) {
            var key = response.key;
            self.setState({
                api_key: key,
            });
        })
    }

    handleGenerateApiKey() {
        var self = this;
        apiIntegrations.generateApiKey(function(response) {
            var key = response.key;
            self.setState({
                api_key: key,
            });
        })
    }

    render() {
        return (
            <div class="col-md-8 col-sm-7 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> API Integration</h4>
                        <p class="category">Integration</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12" style={{marginTop: '25px', marginBottom: '25px'}}>
                                <div class="col-md-12">
                                    <label>API key</label>
                                </div>
                                <div class="col-md-6 col-sm-8 col-xs-12">
                                {this.state.api_key == null ? (
                                <input type="text" class="form-control" name="apikey" value="" id="apikey" readOnly />
                                ) : (
                                <input type="text" class="form-control" name="apikey" value={this.state.api_key} id="apikey" readOnly />
                                )}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b></b></p>
                            </div>
                            <div id="colorSelects">
                                <div class="col-md-12">
                                    {this.state.api_key == null ? (
                                    <div class="col-md-5 col-md-offset-1 col-sm-6 col-sm-offset-0 col-xs-12 col-xs-offset-2">
                                        <button type="button" id="save-color-coding" data-loading-text="Loading..." class="btn btn-warning btn-info btn-fill" autoComplete="off" onClick={this.handleGenerateApiKey.bind(this)}>
                                            Generate API Key
                                        </button>
                                    </div>
                                    ) : (
                                    <div class="col-md-5 col-md-offset-1 col-sm-6 col-sm-offset-0 col-xs-12 col-xs-offset-2">
                                        <button type="button" id="save-color-coding" data-loading-text="Loading..." class="btn btn-warning btn-info btn-fill" autoComplete="off" onClick={this.handleGenerateApiKey.bind(this)}>
                                            Refresh API Key
                                        </button>
                                    </div>
                                    )}
                                    <div class="col-md-5 col-md-offset-1 col-sm-6 col-sm-offset-0 col-xs-12 col-xs-offset-2" style={window.innerWidth < 768 ? {marginTop: 10} : {}}>
                                        <button type="button" id="delete-color-coding" data-loading-text="Loading..." class="btn btn-primary btn-danger btn-fill" autoComplete="off" onClick={this.handleDeleteApiKey.bind(this)}>
                                            Remove API Key
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}; 


// WEBPACK FOOTER //
// app/components/Settings/Integrations/APIIntegrations.jsx